import React, { useState } from 'react';
import '../../../entrydoor.css';

const ScreenFrameColor = ({ value, onChange, label = 'Screen Frame Color', disabled = false }) => {
    const [selectedScreenFrameColor, setSelectedScreenFrameColor] = useState(value || "White");

    const handleScreenFrameColorChange = (e) => {
        setSelectedScreenFrameColor(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="ScreenFrameColor">{label}</label>
            <select
                disabled={disabled}
                id="ScreenFrameColor"
                value={selectedScreenFrameColor}
                onChange={handleScreenFrameColorChange}
            >
               <option value="" disabled hidden>Select an option</option>
                <option value="White">{setSelectedScreenFrameColor === "White" ? "White ✔" : "White"}</option>
                <option value="Gentek">{setSelectedScreenFrameColor === "Gentek" ? "Gentek ✔" : "Gentek"}</option>
            </select>
        </div>
    );
};

export default ScreenFrameColor;
